export default __webpack_public_path__ + "static/media/azulo_icon.3117f6ff.svg";